import { render } from "./MultilangTextarea.vue?vue&type=template&id=1a39e7c2"
import script from "./MultilangTextarea.vue?vue&type=script&lang=js"
export * from "./MultilangTextarea.vue?vue&type=script&lang=js"

import "./MultilangTextarea.vue?vue&type=style&index=0&id=1a39e7c2&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__